module.exports = __webpack_public_path__ + "img/moneymex_desc_vi2.ba3de88b.webp";